import React, { useState, useEffect } from "react";
// reactstrap
import {
  Collapse,
  Modal,
  ModalBody,
  ModalHeader,
  Col,
  Row,
  Button,
  Table,
  Card,
  CardBody,
} from "reactstrap";
// select
import Select from "react-select";
// redux
import { connect } from "react-redux";
// react router dom
import { useLocation } from "react-router-dom";
// alerta
import SweetAlert from "react-bootstrap-sweetalert";
// mascara
import { inputMask } from "../../../utils/helpers/masks/masks";
import { cpfValidator } from "../../../utils/helpers/masks/validations";
// service
import { newParticipant } from "../../../utils/services/participants";
import { getGroups } from "../../../utils/services/group";
import { addLoginInNotificationsScheduled } from "../../../utils/services/notification";
import { createQuotas } from "../../../utils/services/quotas";
import { getStatusRsvp } from "../../../utils/services/statusRsvp";
// componentes
import CompositonModals from "./Session/CompositionModals";
import ButtonSpinner from "../../../components/Buttons/ButtonSpinner";
import DeleteButton from "../../../components/Buttons/DeleteButton";
// telefone internacional
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import { paisesPt } from "../../../utils/helpers/data/countries";

function NewParticipant(props) {
  const { isOpen, toggle } = props;
  const location = useLocation();

  // state de modal
  const [modalBackdrop, setModalBackdrop] = useState(false);
  // state de confirmação de criação
  const [successDlg, setSuccessDlg] = useState(false);
  // state de grupos
  const [groups, setGroups] = useState([]);
  const [allGroups, setAllGroups] = useState(false);
  // state de grupos selecionados
  const [groupsMulti, setGroupsMulti] = useState([]);
  // state dos campos do formulário
  const [email, setEmail] = useState();
  const [nome, setNome] = useState();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [titleQrCode, setTitleQrCode] = useState("");
  const [codeQrCode, setCodeQrCode] = useState("");
  const [infoAccess, setInfoAccess] = useState("");
  const [cpf, setCpf] = useState("");
  const [phone, setPhone] = useState("");
  const [company, setCompany] = useState("");
  const [office, setOffice] = useState("");
  const [code1, setCode1] = useState("");
  const [code2, setCode2] = useState("");
  const [code3, setCode3] = useState("");
  const [chat, setChat] = useState("");
  const [restricaoHospedagem, setRestricaoHospedagem] = useState("");
  // state do Status RSVP (só carregado quando o produto RSVP está habilitado)
  const [statusRsvpList, setStatusRsvpList] = useState([]);
  const [statusRsvpSelected, setStatusRsvpSelected] = useState(null);
  // state de modais de sessão
  const [showModalNewSession, setShowModalNewSession] = useState(false);
  const [showModalEditSession, setShowModalEditSession] = useState(false);
  const [showModalDeleteSession, setShowModalDeleteSession] = useState(false);
  // state de sessões
  const [sessionItem, setSessionItem] = useState("");
  const [sessions, setSessions] = useState([]);
  // state de erros
  const [nameError, setNameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [sectionError, setSectionError] = useState();
  const [cpfError, setCpfError] = useState("");
  const [foneError, setFoneError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [passwordConfirmError, setPasswordConfirmError] = useState("");
  const [passwordConfirmValidationError, setPasswordConfirmValidationError] =
    useState("");
  // state de exibir/ocultar senha
  const [viewPass, setViewPass] = useState(false);
  const [viewPassConfirm, setViewPassConfirm] = useState(false);
  const [passwordChecked, setPasswordChecked] = useState(false);
  // state de notificação
  const [updateNotification, setUpdateNotification] = useState(false);
  // state de produtos do evento
  const [productsList, setProductsList] = useState([]);
  // state de collapse de sessão
  const [isOpenSession, setIsOpenSession] = useState(true);
  // state de props dos modais de sessão
  const [propsModals, setPropModals] = useState({});
  // state de loading
  const [isLoading, setIsLoading] = useState(false);

  // adiciona uma sessão à lista
  const addSession = (data) => setSessions((prev) => [...prev, data]);

  // atualiza uma sessão existente pelo id
  const updateSession = (id, newData) => {
    setSessions((prev) => {
      return prev.map((session) => {
        if (session.sessionId === id) {
          return { ...session, ...newData };
        }
        return session;
      });
    });
  };

  // remove uma sessão da lista pelo id
  const deleteSession = (sessionIdToDelete) => {
    setSessions((prev) => {
      return prev.filter((session) => session.sessionId !== sessionIdToDelete);
    });
  };

  // alterna o collapse da seção de sessões
  const toggleSession = () => setIsOpenSession(!isOpenSession);

  // aplica máscara de CPF ao campo
  const handleChange = (value) => {
    inputMask({ mask: "cpf", value, setMaskedValue: setCpf });
  };

  // fecha o modal com backdrop
  function toggleBackdrop() {
    setModalBackdrop(!modalBackdrop);
  }

  // abre/fecha modal de nova sessão
  function toggleModalNewSession() {
    setShowModalNewSession(!showModalNewSession);
  }

  // abre/fecha modal de edição de sessão
  function toggleModalEditSession() {
    setShowModalEditSession(!showModalEditSession);
  }

  // abre/fecha modal de exclusão de sessão
  function toggleModalDeleteSession() {
    setShowModalDeleteSession(!showModalDeleteSession);
  }

  // verifica se deve exibir os campos CPF e telefone com base nos produtos do evento
  function showCpfAndFone() {
    if (!location.state || !location.state.event?.product) return false;

    const products = location.state.event.product;

    const hasOtherProducts = products.some(
      (p) => p.name !== "Distribuição de Cotas",
    );

    return hasOtherProducts;
  }

  // sincroniza as props dos modais de sessão no estado
  function setPropsModals() {
    setPropModals({
      showModalNewSession,
      showModalEditSession,
      showModalDeleteSession,
      toggleModalNewSession,
      toggleModalEditSession,
      toggleModalDeleteSession,
      sessionItem,
      addSession,
      updateSession,
      deleteSession,
      sessions,
    });
  }

  // trata seleção múltipla de grupos, forçando "todos" quando selecionado
  function handleGroupMulti(a) {
    const selected = a.filter((e) => e.value === "todos");
    if (selected.length > 0) {
      a = selected;
      setAllGroups(true);
    } else {
      setAllGroups(false);
    }
    setGroupsMulti(a);
  }

  // valida os campos e envia o formulário de criação do participante
  const submitForm = async (e) => {
    if (!nome) {
      setNameError("O campo Nome é obrigatório.");
      return;
    } else setNameError("");

    if (!email) {
      setEmailError("O campo Email é obrigatório.");
      return;
    } else setEmailError("");

    if (
      cpf.replace(/[^\d]+/g, "").length > 0 &&
      cpf.replace(/[^\d]+/g, "").length < 11
    ) {
      setCpfError("Insira todos os dígitos do CPF");
      return;
    } else setCpfError("");

    if (cpf.replace(/[^\d]+/g, "").length === 11 && !cpfValidator(cpf)) {
      setCpfError("Digite um CPF válido");
      return;
    } else setCpfError("");

    if (phone.slice(0, 3) === "+55") {
      const onlyNumbers = phone.replace(/\D+/g, "");
      if (onlyNumbers.length > 2 && onlyNumbers.length < 12) {
        setFoneError(
          "O campo Telefone para o Brasil precisa ter no mínimo 8 caracteres.",
        );
        return;
      } else setFoneError("");
    } else setFoneError("");

    if (passwordChecked) {
      if (!password) {
        setPasswordError("O campo Senha é obrigatório.");
        return;
      } else setPasswordError("");

      if (password.length < 8 || password.length > 20) {
        setPasswordError("A senha deve conter entre 8 e 20 caracteres");
        return;
      } else setPasswordError("");

      if (!confirmPassword) {
        setPasswordConfirmError("O campo Confirmar senha é obrigatório.");
        return;
      } else setPasswordConfirmError("");

      if (password !== confirmPassword) {
        setPasswordConfirmValidationError(
          "A Senha e a confirmação devem ser iguais.",
        );
        return;
      } else setPasswordConfirmValidationError("");
    }

    if (checkProductExists("Distribuição de Cotas") && sessions.length < 1) {
      setSectionError("O campo Sessão é obrigatório");
      return;
    } else setSectionError("");

    const groupsArray = allGroups
      ? groups.map((e) => ({ grupo: e.id }))
      : groupsMulti.map((e) => ({ grupo: e.value }));

    setIsLoading(true);
    const formData = await newParticipant({
      email: email,
      nome: nome,
      senha: password,
      titleQrCode: titleQrCode,
      codeQrCode: codeQrCode,
      infoAcess: infoAccess,
      token: props.state.global_user_data.data.token,
      id_evento: props.idEvent,
      grupos: groupsArray,
      empresa: company,
      cpf: cpf.replace(/[^\d]+/g, ""),
      telefone: phone,
      cargo: office,
      interesseChat: chat,
      codigoInterno1: code1,
      codigoInterno2: code2,
      codigoInterno3: code3,
      restricaoHospedagem: restricaoHospedagem,
      idStatusRsvp: statusRsvpSelected?.value || null,
    });

    if (formData.message === "EMAIL_ALREADY_REGISTERED") {
      setIsLoading(false);
      setEmailError("O email informado já está cadastrado.");
      return;
    } else setEmailError("");

    if (formData.message === "CPF_ALREADY_REGISTERED_IN_EVENT") {
      setIsLoading(false);
      setCpfError("Esse CPF já está em uso");
      return;
    } else setCpfError("");

    if (formData.message === "created") {
      try {
        const { data } = await addLoginInNotificationsScheduled(
          props?.idEvent,
          formData.data.id,
          props.state.global_user_data.data.token,
          groupsArray,
        );
        setUpdateNotification(data);

        if (checkProductExists("Distribuição de Cotas")) {
          const sessionsTransform = sessions.map((el) => ({
            eventId: props.idEvent,
            loginId: formData.data.id,
            sessionId: el.sessionId,
            companionsNumber: el.companionsNumber,
            accessibilityRestriction: el.accessibilityRestriction,
            typeRestriction: el.accessibilityRestriction
              ? el.typeRestriction
              : "",
            notes: el.notes,
            typeQuota: "manual",
            isSendEmailQuota: true,
            email: email,
            name: nome,
          }));
          await createQuotas({
            jwt: props.state.global_user_data.data.token,
            data: sessionsTransform,
          });
        }
      } catch {
        setIsLoading(false);
      } finally {
        setIsLoading(false);
        setSuccessDlg(true);
      }
    }
  };

  // verifica se o produto está na lista de produtos do usuário logado
  function checkItemMenuExists(menuOption) {
    return productsList.filter((item) => item === menuOption).length > 0;
  }

  // verifica se o produto está na lista de produtos do evento atual
  function checkProductExists(product) {
    if (!location.state) return false;

    return location.state.event.product.some((e) => e.name === product);
  }

  // busca os grupos do evento
  async function getGroupsFunc() {
    try {
      const response = await getGroups({
        jwt: props.state.global_user_data.data.token,
        eventId: props.idEvent,
        offset: 1,
        limit: 0,
        search: "",
      });
      setGroups(response.findOneGroupData.data);
    } catch {}
  }

  useEffect(() => {
    if (cpf.replace(/[^\d]+/g, "").length === 11 && !cpfValidator(cpf)) {
      setCpfError("CPF inválido");
    } else setCpfError("");
  }, [cpf]);

  useEffect(() => {
    getGroupsFunc();
    setProductsList(
      [
        ...new Set(
          props.state.global_user_data.data.foundProducts.map(
            (e) => e.namemainproduct,
          ),
        ),
      ].filter((f) => f !== "Telas de Configuração"),
    );
  }, []);

  useEffect(() => {
    setPropsModals();
  }, [showModalNewSession, showModalEditSession, showModalDeleteSession]);

  // Carrega lista de Status RSVP quando o produto RSVP está habilitado.
  // limit=100 é o teto aceito pelo backend. Filtra pelo contrato ativo.
  useEffect(() => {
    if (!checkProductExists("RSVP")) return;
    const contractId = props.state?.global_user_data?.data?.theme?.[0]?.id;
    if (!contractId) return;
    (async () => {
      const res = await getStatusRsvp({
        contractId,
        offset: 1,
        limit: 100,
        enabled: true,
      });
      if (res && Array.isArray(res.data)) {
        setStatusRsvpList(res.data);
      }
    })();
  }, []);

  return (
    <>
      {checkProductExists("Distribuição de Cotas") && (
        <CompositonModals {...propsModals} />
      )}

      <Modal
        isOpen={isOpen}
        toggle={() => {
          toggleBackdrop();
        }}
        autoFocus={true}
        centered={true}
      >
        {successDlg ? (
          <SweetAlert
            success
            title={"Criado"}
            onConfirm={() => {
              props.getAllParticipants();
              toggle();
              setSuccessDlg(false);
            }}
          >
            <>
              <p>Participante criado com sucesso!</p>
              {updateNotification && (
                <p style={{ color: "#218a64", fontStyle: "italic" }}>
                  As Notificações agendadas foram atualizadas com esse
                  participante.
                </p>
              )}
            </>
          </SweetAlert>
        ) : null}
        <ModalHeader toggle={toggle}>Novo Participante</ModalHeader>
        <ModalBody>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              submitForm(e);
            }}
          >
            <Row style={{ marginBottom: 10 }}>
              <Col lg={12}>
                <div>
                  <label className="form-label">Nome do Participante*</label>
                  <input
                    className="form-control"
                    type="text"
                    defaultValue={nome}
                    onChange={(e) => setNome(e.target.value)}
                  />
                  {nameError && <p style={{ color: "red" }}>{nameError}</p>}
                </div>
              </Col>
            </Row>

            <Row style={{ marginBottom: 10 }}>
              <Col lg={12}>
                <div>
                  <label className="form-label">Email do Participante*</label>
                  <input
                    className="form-control"
                    type="email"
                    defaultValue={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  {emailError && <p style={{ color: "red" }}>{emailError}</p>}
                </div>
              </Col>
            </Row>

            {showCpfAndFone() && (
              <Row style={{ marginBottom: 10 }}>
                <Col lg={6}>
                  <div>
                    <label className="form-label">CPF</label>
                    <input
                      className="form-control"
                      value={cpf}
                      onChange={({ target }) => handleChange(target.value)}
                    />
                    {cpfError && <p style={{ color: "red" }}>{cpfError}</p>}
                  </div>
                </Col>
                <Col lg={6}>
                  <div>
                    <label>Telefone</label>
                    <PhoneInput
                      defaultCountry="br"
                      value={phone}
                      onChange={(phone) => setPhone(phone)}
                      countries={paisesPt}
                      inputStyle={{ width: "100%" }}
                    />
                    {foneError && <p style={{ color: "red" }}>{foneError}</p>}
                  </div>
                </Col>
              </Row>
            )}

            {checkItemMenuExists("APP Eventos Plus") &&
              checkProductExists("APP Eventos Plus") && (
                <Row style={{ marginBottom: 10 }}>
                  <Col md={6}>
                    <div className="form-check form-check-end">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        value=""
                        id="checkpassword"
                        onChange={() => setPasswordChecked(!passwordChecked)}
                      />
                      <label htmlFor="checkpassword">Senha</label>
                    </div>
                  </Col>
                </Row>
              )}

            {passwordChecked && (
              <>
                <Row style={{ marginBottom: 10 }}>
                  <Col lg={12}>
                    <div>
                      <label className="form-label">Senha*</label>
                      <div
                        className="mb-3"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <input
                          className="form-control"
                          type={!viewPass ? "password" : "text"}
                          defaultValue={password}
                          onChange={(e) => setPassword(e.target.value)}
                        />
                        <a onClick={() => setViewPass(!viewPass)}>
                          {viewPass ? (
                            <i className="mdi mdi-eye-off-outline icon-password" />
                          ) : (
                            <i className="mdi mdi-eye-outline icon-password" />
                          )}
                        </a>
                      </div>
                      {passwordError && (
                        <p style={{ color: "red" }}>{passwordError}</p>
                      )}
                    </div>
                  </Col>
                </Row>

                <Row style={{ marginBottom: 10 }}>
                  <Col lg={12}>
                    <div>
                      <label className="form-label">Confirmar Senha*</label>
                      <div
                        className="mb-3"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <input
                          className="form-control"
                          type={!viewPassConfirm ? "password" : "text"}
                          defaultValue={confirmPassword}
                          onChange={(e) => setConfirmPassword(e.target.value)}
                        />
                        <a onClick={() => setViewPassConfirm(!viewPassConfirm)}>
                          {viewPassConfirm ? (
                            <i className="mdi mdi-eye-off-outline icon-password" />
                          ) : (
                            <i className="mdi mdi-eye-outline icon-password" />
                          )}
                        </a>
                      </div>
                      {passwordConfirmError && (
                        <p style={{ color: "red" }}>{passwordConfirmError}</p>
                      )}
                    </div>
                  </Col>
                  {passwordConfirmValidationError && (
                    <p style={{ color: "red" }}>
                      {passwordConfirmValidationError}
                    </p>
                  )}
                </Row>
              </>
            )}

            {(checkProductExists("APP Eventos Plus") ||
              checkProductExists("Inteegra MOBI")) && (
              <>
                <Row style={{ marginBottom: 10 }}>
                  <Col md={6}>
                    <div>
                      <label className="form-label">Título QRCode</label>
                      <input
                        className="form-control"
                        type="text"
                        defaultValue={titleQrCode}
                        onChange={(e) => setTitleQrCode(e.target.value)}
                      />
                    </div>
                  </Col>
                  <Col md={6}>
                    <div>
                      <label className="form-label">Código QRCode</label>
                      <input
                        className="form-control"
                        type="text"
                        defaultValue={codeQrCode}
                        onChange={(e) => setCodeQrCode(e.target.value)}
                      />
                    </div>
                  </Col>
                </Row>

                <Row style={{ marginBottom: 10 }}>
                  <Col lg={12}>
                    <div>
                      <label className="form-label">
                        Informações de Acesso
                      </label>
                      <input
                        className="form-control"
                        type="text"
                        defaultValue={infoAccess}
                        onChange={(e) => setInfoAccess(e.target.value)}
                      />
                    </div>
                  </Col>
                </Row>

                <Row style={{ marginBottom: 10 }}>
                  <Col md={12}>
                    <label className="form-label">Bio do Chat</label>
                    <input
                      className="form-control"
                      type="text"
                      onChange={(e) => setChat(e.target.value)}
                    />
                  </Col>
                </Row>
              </>
            )}
            {checkProductExists("Distribuição de Cotas") && (
              <Row style={{ marginBottom: 10 }}>
                <Col md={12}>
                  <label className="form-label" onClick={toggleSession}>
                    Sessão*
                    <i
                      className={
                        isOpenSession
                          ? "mdi mdi-arrow-up"
                          : "mdi mdi-arrow-down"
                      }
                      style={{ marginTop: 2, cursor: "pointer" }}
                    />
                  </label>
                </Col>
                <Collapse isOpen={isOpenSession}>
                  <Card
                    style={{
                      border: "0.5px solid lightgray",
                      marginBottom: "0.5px",
                    }}
                  >
                    <CardBody>
                      <Row
                        style={{
                          justifyContent: "flex-end",
                          marginRight: "5px",
                        }}
                      >
                        <Button
                          color="success"
                          className="btn-rounded waves-effect waves-light events-button-add-lg"
                          style={{ alignItems: "center", width: "auto" }}
                          onClick={() => {
                            toggleModalNewSession();
                          }}
                        >
                          Adicionar Sessão
                        </Button>
                      </Row>

                      <div style={{ marginTop: "10px" }}>
                        <Table striped className="table mb-0">
                          <thead style={{ backgroundColor: "#e4e4e4" }}>
                            <tr>
                              <th>Sessão</th>
                              <th>Quantidade de Ingressos</th>
                              <th>Restrição</th>
                              <th>Ações</th>
                            </tr>
                          </thead>
                          <tbody>
                            {sessions &&
                              sessions.map((item) => (
                                <tr key={item.sessionId}>
                                  <td>{item.title}</td>
                                  <td>{item.companionsNumber}</td>
                                  <td>
                                    {item.accessibilityRestriction
                                      ? "Sim"
                                      : "Não"}
                                  </td>
                                  <td>
                                    <i
                                      className={"mdi mdi-pencil"}
                                      style={{
                                        color: "green",
                                        fontSize: 17,
                                        cursor: "pointer",
                                      }}
                                      onClick={() => {
                                        setSessionItem(item);
                                        toggleModalEditSession();
                                      }}
                                    />
                                    <DeleteButton
                                      onClick={() => {
                                        setSessionItem(item);
                                        toggleModalDeleteSession();
                                      }}
                                      color="red"
                                      fontSize={17}
                                    />
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </Table>
                      </div>
                    </CardBody>
                  </Card>
                  {sectionError && (
                    <a style={{ color: "red" }}>{sectionError}</a>
                  )}
                </Collapse>
              </Row>
            )}

            <Row style={{ marginBottom: 10 }}>
              <Col md={6}>
                <label className="form-label">Empresa</label>
                <input
                  className="form-control"
                  type="text"
                  onChange={(e) => setCompany(e.target.value)}
                />
              </Col>

              <Col md={6}>
                <label className="form-label">Cargo</label>
                <input
                  className="form-control"
                  type="text"
                  onChange={(e) => setOffice(e.target.value)}
                />
              </Col>
            </Row>

            <Row style={{ marginBottom: 10 }}>
              <Col md={12}>
                <label className="form-label">Código interno 1</label>
                <input
                  className="form-control"
                  type="text"
                  onChange={(e) => setCode1(e.target.value)}
                />
              </Col>
            </Row>

            <Row style={{ marginBottom: 10 }}>
              <Col md={6}>
                <label className="form-label">Código interno 2</label>
                <input
                  className="form-control"
                  type="text"
                  onChange={(e) => setCode2(e.target.value)}
                />
              </Col>

              <Col md={6}>
                <label className="form-label">Código interno 3</label>
                <input
                  className="form-control"
                  type="text"
                  onChange={(e) => setCode3(e.target.value)}
                />
              </Col>
            </Row>

            {checkProductExists("Match de Hospedagem") && (
              <Row>
                <Col md={12}>
                  <label className="form-label">Restrição de hospedagem</label>
                  <input
                    className="form-control"
                    type="text"
                    onChange={(e) => setRestricaoHospedagem(e.target.value)}
                  />
                </Col>
              </Row>
            )}

            <Row style={{ marginTop: 10, marginBottom: 10 }}>
              <Col lg={12}>
                <div>
                  <label className="form-label">Grupos</label>
                  <Select
                    value={groupsMulti}
                    placeholder={"Selecione"}
                    isMulti={true}
                    onChange={(e) => {
                      handleGroupMulti(e);
                    }}
                    noOptionsMessage={() => "Nenhuma opção encontrada"}
                    options={[
                      {
                        options:
                          groups?.length > 0 && !allGroups
                            ? [
                                { label: "TODOS", value: "todos" },
                                ...groups.map((e) => {
                                  return { label: e.name, value: e.id };
                                }),
                              ]
                            : [],
                      },
                    ]}
                    classNamePrefix="select2-selection"
                  />
                </div>
              </Col>
            </Row>

            {checkProductExists("RSVP") && (
              <Row style={{ marginTop: 10, marginBottom: 10 }}>
                <Col md={12}>
                  <label className="form-label">Status RSVP</label>
                  <Select
                    value={statusRsvpSelected}
                    placeholder="Selecione"
                    onChange={(opt) => setStatusRsvpSelected(opt)}
                    options={statusRsvpList.map((s) => ({
                      label: s.description,
                      value: s.id,
                    }))}
                    noOptionsMessage={() => "Nenhuma opção encontrada"}
                    classNamePrefix="select2-selection"
                    isClearable
                  />
                </Col>
              </Row>
            )}

            <Row
              style={{
                width: "100%",
                margin: "auto",
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Button
                color="danger"
                style={{ width: 80, marginRight: 10 }}
                onClick={() => toggle()}
              >
                Fechar
              </Button>
              <ButtonSpinner isLoading={isLoading} title={"Salvar"} />
            </Row>
          </form>
        </ModalBody>
      </Modal>
    </>
  );
}

const mapStateToProps = function (state) {
  return { state: state };
};

export default connect(mapStateToProps)(NewParticipant);
